export enum ExecutionDataType {
    Integer = 'integer',
    Double = 'double',
    Datetime = 'datetime',
    Boolean = 'boolean',
    String = 'string',
}
